import { createContext, useContext } from 'react';
import { API } from '@shared/types/api';

export interface Billing {
  subscriptions?: NonNullable<
    NonNullable<API.GetBillingQuery['billing']>['customer']['subscriptions']
  >[number][];
  status?: API.BillingSubscriptionStatus;
  isPaidPlan?: boolean;
  messages?: number;
  messageLimit?: number;
  cards?: number;
  cardLimit?: number;
  storage?: number;
  storageLimit?: number;
  numUsers?: number;
}

export interface BillingContextValue {
  billing: Billing;
  loading: boolean;
  refetch: () => Promise<void>;
}

export const defaultBilling: Billing = {};

export const BillingContext = createContext<BillingContextValue>({
  billing: defaultBilling,
  loading: false,
  refetch: () => Promise.resolve(),
});

export function useBillingContext() {
  return useContext(BillingContext);
}
